// This import loads the firebase namespace along with all its type information.
import MetricGraphScreen from './metric-graph-screen-model'

export async function load_metricGraphScreens(): Promise<MetricGraphScreen[]> {
  throw 'Not implemented'
}

export async function delete_metricGraphScreen(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricGraphScreen(): Promise<MetricGraphScreen> {
  throw 'Not implemented'
}
